module.exports = __webpack_public_path__ + "img/jira.b72d9f20.png";